import Vue from 'vue';
import gql from 'graphql-tag';
import _ from 'lodash';

import graphqlClient from '../../helpers/graphql';

const state = {
  activities: [],
  classes: [],
  conferences: []
};

const mutations = {
  setActivities(state, activities) {
    Vue.set(state, 'activities', activities);
  },
  setClasses(state, classes) {
    Vue.set(state, 'classes', classes);
  },
  setConferences(state, conferences) {
    Vue.set(state, 'conferences', conferences);
  }
};

const actions = {

  async fetchServices({ commit }) {
    const response = await graphqlClient.query({
      query: gql`
query {
  activities(where: {show: true}) {
    id
    name
    acceptRegistrations
    registrationMaximum
    description
    date
    type
    price {
      priceMember
      priceRegular
    }
    priceMinor {
      priceMember
      priceRegular
    }
    surplusNonResident {
      priceMember
      priceRegular
    }
    surplusNonResidentMinor {
      priceMember
      priceRegular
    }
    registrations {
      confirmed
      member {
        id
      }
    }
  }
  classes(where: {show: true}) {
    id
    date
    type
    category
    description
    informations
    acceptRegistrations
    inscriptionLimit
    registrationNumber
    maximumInscriptions
    allowInscriptionsAfter
    price {
      priceMember
      priceRegular
    }
    priceMinor {
      priceMember
      priceRegular
    }
    surplusNonResident {
      priceMember
      priceRegular
    }
    surplusNonResidentMinor {
      priceMember
      priceRegular
    }
    registrations {
      confirmed
      member {
        id
      }
    }
  }
  conferences(where: {show: true}) {
    id
    name
    description
    media {
      url
    }
    date
    acceptRegistrations
    registrationMaximum
    speakers {
      name
    }
    price {
      priceMember
      priceRegular
    }
    priceMinor {
      priceMember
      priceRegular
    }
    surplusNonResident {
      priceMember
      priceRegular
    }
    surplusNonResidentMinor {
      priceMember
      priceRegular
    }
    registrations {
      confirmed
      member {
        id
      }
    }
  }
}
      `
    });
    commit('setActivities', response.data.activities);
    commit('setClasses', response.data.classes);
    commit('setConferences', response.data.conferences);
  }
};

const getters = {
  activities: state => {
    return state.activities;
  },
  activity: state => id => {
    return _.find(state.activities, (a) => a.id === id);
  },
  classes: state => {
    return state.classes;
  },
  class: state => id => {
    return _.find(state.classes, (a) => a.id === id);
  },
  conferences: state => {
    return state.conferences;
  },
  conference: state => id => {
    return _.find(state.conferences, (a) => a.id === id);
  }
};

export const services = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
